<template>
  <div>
    <tz-banner
      :title="cms.page.title"
      :description="cms.page.last_updated"
      :is-light="true"
      :has-overlay="false"
    />
    <div class="wl-legal">
      <section class="sh-wysiwyg">
        <tz-markdown :content="cms.page.content" />
      </section>
    </div>
  </div>
</template>

<script>
import Meta from '@/assets/js/shared/misc/meta.mjs';

// Components
import TzMarkdown from '@trazi/tz-markdown/src/tz-markdown.vue';
import TzBanner from '@trazi/tz-banner/src/tz-banner.vue';

export default {
  components: {
    TzMarkdown,
    TzBanner
  },
  asyncData({ $config: { website } }) {
    if (!process.server) {
      return;
    }

    const cms = {
      page: require(`@/assets/cms/pages/terms-conditions.json`),
      global: require(`@/assets/cms/global.json`)
    };

    return { cms };
  },
  head() {
    return {
      title: this.cms.page.page_title,
      meta: this.cms.page.meta ? Meta.convertToNuxtMeta(this.cms.page.meta) : []
    };
  }
};
</script>
